<mat-drawer-container class="countable-drawer">

  <mat-drawer-content class="overflow-hidden">
    <div class="contant-block-main flex-1 h-100 overflow-hidden balance-sheet-wrapper d-flex flex-column">
      <div class="page-title-block align-items-start pt-24">
        <div class="title-block-middle d-flex flex-column align-items-center flex-1">
          <h3 class="title">{{ clientName }}</h3>
          <h3 class="title">{{ headerText }}</h3>
          <ng-container *ngIf="!isSubheaderClicked">
              <h6 class="title hover-action d-flex flex-row align-items-center gap-8" style="min-height:36px;">{{subheaderText}} {{currEndYearDate | appCountableTimeZone:'MMMM d, yyyy':'UTC'}}
              <ng-container>
                <button mat-button class="button-small-icon hover-action-item" *ngIf="shortCutMenuDetails.isenglock === 0" (click)="focusInput();isSubheaderClicked = true; oldSubheaderText = subheaderText">
                    <i class="fa-regular fa-pen fs-15"></i>
                </button>
              </ng-container>
            </h6>
          </ng-container>
          <ng-container *ngIf="isSubheaderClicked">
            <mat-form-field class="fixed-label form-field-medium icon-form-after action-2" style="width: 300px">
              <input matInput [(ngModel)]="subheaderText" type="text" #focusInputField (click)="$event.stopPropagation();">
              <div matSuffix class="actions border-start">
                <button mat-button color="success" title="Save" (click)="saveHeaderNote()">
                  <i class="fa-regular fa-check"></i>
                </button>
                <button mat-button color="cancel" title="Cancel" (click)="isSubheaderClicked = false; subheaderText = oldSubheaderText">
                  <i class="fa-regular fa-xmark clear-icon"></i>
                </button>
              </div>
            </mat-form-field>
            <h6 class="title">{{currEndYearDate | appCountableTimeZone:'MMMM d, yyyy':'UTC'}}</h6>
          </ng-container>
        </div>
      </div>

      <div class="balance-sheet-container-body py-24 px-20 overflow-hidden">
        <div class="card h-100 overflow-auto">
          <div class="card-header button-group justify-content-end" >
            <span (click)="$event.stopPropagation()">
              <button mat-button mat-flat-button color="primary" class="button-medium" *ngIf="!isColEditable()" (click)="addColumn()" title="Add Column"
              [disabled]="editRowUUID !== '' || shortCutMenuDetails.isenglock !== 0"  [ngClass]="{'btn-disabled': (editRowUUID !== '')}">
                <div class="flexbox-row gap-8">
                    <i class="fa-solid fa-plus"></i>
                    <span class="button-label">Add Column</span>
                </div>
              </button>
            </span>
            <button mat-button mat-stroked-button color="dark" class="btn-medium-icon" title="Collapse All" (click)="togglePannels('C');" *ngIf="allGroupsExpanded">
                <i class="fa-regular fa-arrow-down-left-and-arrow-up-right-to-center fs-3 text-primary"></i>
            </button>
            <button mat-button mat-stroked-button color="dark" class="btn-medium-icon" title="Expand All" (click)="togglePannels('E');" *ngIf="!allGroupsExpanded">
                <i class="fa-regular fa-arrow-up-right-and-arrow-down-left-from-center fs-3 text-primary"></i>
            </button>
            <button mat-button mat-stroked-button color="dark" class="button-medium" title="Hide and Rearrange Columns" [matMenuTriggerFor]="hideMenu"  #hidingMenu="matMenuTrigger" [disabled]="isMainHideBtnDisabled()">
              <span class="flexbox-row gap-8">
                <i class="fa-regular fa-eye"></i>
                <span class="button-label">Hide</span>
              </span>
            </button>
            <mat-menu #hideMenu="matMenu" class="hide card template-block-main" xPosition="after" yPosition="below">
              <div class="card-header justify-content-end py-1 px-3 pt-0 min-h-auto" (click)="$event.stopPropagation()">
                <button mat-button class="button-text" (click)="clearAllhide()">
                  <i class="fa-regular fa-xmark clear-icon"></i>Clear all
                </button>
              </div>
              <mat-list role="list" class="templates-list-items card-body p-0" cdkDropList cdkDropListOrientation="vertical" (cdkDropListDropped)="dropColumn($event)">
                <mat-list-item role="listitem" (click)="$event.stopPropagation()">
                  <span class="list-item-content">
                    <span class="dragable-icon invisible">
                        <i class="fa-solid fa-grip-dots-vertical"></i>
                    </span>
                    <mat-checkbox name="selectAll" [checked]="isAllSelected()" [disabled]="(copyColumnsFromApi.length - 1) == 0" (change)="onSelectAllChecked($event)">
                      Select All
                    </mat-checkbox>
                  </span>
                </mat-list-item>
                <mat-list-item role="listitem" cdkDrag *ngFor="let column of copyColumnsFromApi">
                  @if(column.colName !== 'Retained Earnings') {
                  <span class="list-item-content">
                    <span class="dragable-icon">
                        <i class="fa-solid fa-grip-dots-vertical"></i>
                    </span>
                    <span class="item-checkbox" (click)="$event.stopPropagation();">
                      <mat-checkbox [(ngModel)]="column.isHide" [ngModelOptions]="{standalone: true}" (change)="onChangeHide(column)"></mat-checkbox>
                    </span>
                    <span class="item-title">{{ column.colName}}</span>
                  </span>
                }
                </mat-list-item>
              </mat-list>
              <div class="card-footer px-3 py-1 button-group">
                <button mat-button mat-flat-button color="primary" title="Apply" class="button-small flex-1" [disabled]="isApplyHideDisabled()" (click)="onHideColumn()">Apply</button>
                <button mat-button mat-stroked-button color="dark" title="Cancel" class="button-small flex-1" (click)="closeHide()">Cancel</button>
              </div>
            </mat-menu>
          </div>

          <div class="card-body p-0">
            <div class="table-responsive" cdkScrollable>
              <mat-table #table [dataSource]="dataSource" cdkDropList (cdkDropListDropped)="drop($event)" cdkDropListData="dataSource"  [cdkDropListDisabled]="dragDisabled" class="table-countable editable hover-action cell-p-8 w-auto" style="min-width:1080px;">
                <ng-container matColumnDef="description">
                  <mat-header-cell *matHeaderCellDef class="fs-12" style="min-width: 200px;"> </mat-header-cell>
                  <mat-cell *matCellDef="let element; let i = index" class="row-icons" style="min-width: 200px;" [style]="applyRowActionIcons(element)? 'padding-left: 12px;' : ''">
                    <div *ngIf="!isAddRowBtn(element); else addRow" [ngClass]="{ellipse: !(isRowInAddMode(element) || isRowInEditMode(element))}">

                      <ng-container *ngIf="isRowInAddMode(element) || isRowInEditMode(element); else showRowName">

                        <ng-container *ngIf="element.year === editYear">
                          <mat-form-field class="fixed-label label-none form-field-medium" floatLabel="always">
                            <mat-label>Enter text here</mat-label>
                            <input #rowDesc id="rowDesc" matInput type="text" class="text-end" placeholder="Enter text here" ngModel="{{element.rowName}}" (blur)="updateRowName(element, rowDesc.value)" class="valueDisplay " [disabled]="element.isFromRf" />
                          </mat-form-field>
                          <div class="button-group row-actions" [disabled]="shortCutMenuDetails.isenglock !== 0">
                            <button mat-button class="button-smaller-icon" title="Save" *ngIf="isRowEditable(element.year)" (click)="saveRow(element.year)" [disabled]="isSaveRowDisabled()" [ngClass]="{'btn-disabled': isSaveRowDisabled()}">
                                <i class="fa-regular fa-check text-success"></i>
                            </button>
                            <button mat-button class="button-smaller-icon" title="Cancel" *ngIf="isRowEditable(element.year)" (click)="cancelSaveRow(editRowUUID, element.year)">
                                <i class="fa-regular fa-xmark text-error"></i>
                            </button>
                          </div>
                        </ng-container>


                        <mat-form-field class="fixed-label label-none form-field-medium" floatLabel="always" *ngIf="element.year !== editYear">
                          <mat-label>Enter text here</mat-label>
                          <input #rowDesc id="rowDesc" class="text-end" matInput type="text" ngModel="{{element.rowName}}" readonly />
                        </mat-form-field>
                      </ng-container>

                      <ng-template #showRowName>
                        <div class="d-flex flex-row align-items-center gap-4">
                          <button mat-button class="button-text tooltip-right hover-action-item dragCursor" *ngIf="applyRowActionIcons(element)" title="Drag" (mousedown)="dragDisabled = false;">
                            <i class="fa-solid fa-grip-dots-vertical fs-18"></i>
                          </button>
                          <button mat-button class="button-text tooltip-right hover-action-item w-16 kebab-button" title="Actions" [matMenuTriggerFor]="rowaction"  #hidingMenu="matMenuTrigger" [disabled]="isMainHideBtnDisabled()" *ngIf="applyRowActionIcons(element)">
                            <i class="fas fa-ellipsis-vertical"></i>
                          </button>
                          <mat-menu #rowaction="matMenu" class="hide card template-block-main" xPosition="after" yPosition="below">
                            <mat-list role="list" class="templates-list-items card-body p-0" cdkDropList cdkDropListOrientation="vertical" (cdkDropListDropped)="dropColumn($event)">
                              <mat-list-item role="listitem" [disabled]="(element.isFromRf && element.isPreviousYear) || shortCutMenuDetails.isenglock !== 0">
                                  <button mat-button class="flexbox-row gap-8 px-2 py-1 border-bottom" (click)="editRow(element)" [disabled]="element.rowUUID === editRowUUID">
                                    <i class="fa-regular fa-pen fs-15"></i>
                                    <span class="button-label">Edit</span>
                                  </button>
                              </mat-list-item>
                              <mat-list-item role="listitem" [disabled]="(element.isFromRf && element.isPreviousYear)|| shortCutMenuDetails.isenglock !== 0">
                                <button mat-button class="flexbox-row gap-8 px-2 py-1" (click)="openDeleteRowDialog(element)" [disabled]="element.rowUUID === editRowUUID || element.isFromRf">
                                    <i class="fa-regular fa-trash-can"></i>
                                    <span class="button-label">Delete</span>
                                </button>
                              </mat-list-item>
                            </mat-list>
                          </mat-menu>
                          <span title="{{element.rowName}}" class="text-ellipse" [ngClass]="{'fw-semibold left-space': (['1','2','3','4','endTotalBal'].includes(element.rowUUID)), 'left-space': !applyRowActionIcons(element)}">
                            {{ element.rowName }}
                          </span>
                        </div>
                      </ng-template>
                    </div>

                    <ng-template #addRow>
                      <div class="button-group left-space">
                        <button mat-button mat-flat-button color="primary" class="button-medium" *ngIf="!isRowEditable(element.year)" (click)="addNewRow(element, i)"
                          title="{{element.rowName}}" [disabled]="((editYear !== '') && (element.year !== editYear)) || (editColumnUUID !== '') ||shortCutMenuDetails.isenglock !== 0">
                          <div class="flexbox-row gap-8">
                              <i class="fa-solid fa-plus"></i>
                              <span class="button-label">{{element.rowName}}</span>
                          </div>
                        </button>
                      </div>
                    </ng-template>

                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="notes">
                  <mat-header-cell *matHeaderCellDef title="Notes to FS" class="text-end justify-content-end fs-12" style="max-width:300px;">Notes to FS</mat-header-cell>
                  <mat-cell *matCellDef="let element" class="notesColumn text-end justify-content-end" style="max-width:300px;">
                    <button mat-button class="button-text" *ngIf="notAnAddAndTotalRow(element) && !(['1','2','3','4'].includes(element.rowUUID)) else endTotal" (click)="openNotesOverlay(element)">
                      <i class="fa-regular fa-plus"></i>
                    </button>
                    <ng-container *ngFor="let notes of element.notesData|sortBy let index = index; let l = count">
                      <button class="transparent-btn map-num-btn flat-btn" title="{{notes.noteName}}" (click)="navigateToNotesToFs(notes.engNoteId)">
                        <div class="ls-btn"><span class="ellipse"> {{notes.engNoteId}}<span *ngIf="index+1 != l">,</span>
                          </span>
                        </div>
                      </button>
                    </ng-container>

                    <ng-template #endTotal>
                      <div></div>
                    </ng-template>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="totStockEq">
                  <mat-header-cell *matHeaderCellDef title="Total Stockholder Equity" class="text-wrap text-end justify-content-end fs-12" style="min-width: 150px;max-width:150px;">Total Stockholder Equity</mat-header-cell>
                  <mat-cell *matCellDef="let element" class="text-end justify-content-end" style="min-width: 150px;max-width:150px;">

                    <div *ngIf="notAnAddAndTotalRow(element); else endTotal" class="flex-box full-row default-row">
                      <span *ngIf="!isRowInAddMode(element); else editMode" class="valueDisplay ellipse " title="{{showFormattedNumber(getTotStockEq(element))}}">
                        {{ showFormattedNumber(getTotStockEq(element)) }}
                      </span>
                      <ng-template #editMode>
                        <mat-form-field class="fixed-label label-none form-field-medium" floatLabel="always">
                          <mat-label>Label</mat-label>
                          <input matInput type="number" class="text-end" placeholder="Value" ngModel="{{ getTotStockEq(element) }}" readonly />
                        </mat-form-field>
                      </ng-template>
                    </div>

                    <ng-template #endTotal>
                      <span class="fw-semibold" style="padding-right:10px;" *ngIf="isAddRowBtn(element); else totalBal"></span>
                      <ng-template #totalBal>
                        <span class="fw-semibold" style="padding-right:10px;" [ngClass]="(element.rowUUID === 'crossCheck' ? 'crosscheckValues text-error fw-medium' : '')" title="{{ showFormattedNumber(getTotEndBalStockEq(element))}}">
                          {{ showFormattedNumber(getTotEndBalStockEq(element)) }}
                        </span>
                      </ng-template>
                    </ng-template>
                  </mat-cell>
                </ng-container>

                <ng-container *ngFor="let column of columnsFromApi; let i = index" matColumnDef="{{ column.columnUUID }}">
                  <mat-header-cell *matHeaderCellDef title="{{ column.colName}}" class="cell-hover-action justify-content-end gap-8 fs-12" style="min-width: 150px;max-width:150px;" [ngClass]="{'table-header-editable': renameColumnUUID === column.columnUUID}">
                    <div (clickOutside)="clickOutside(column)" (click)="$event.stopPropagation()">
                      <ng-container  *ngIf="isColumnInEditMOde(column) || renameColumnUUID === column.columnUUID; else showColumn">
                        <mat-form-field class="fixed-label label-none icon-form-after action-2 w-100 form-field-smaller" floatLabel="always" >
                            <input #colHeader id="colHeader" matInput type="text" class="text-left" [(ngModel)]="column.colName" (blur)="setColHeader(column)" placeholder="Enter Text Here" />
                            <div matSuffix class="actions border-start" >
                                <button mat-button color="success" title="Save" class="show-always" (click)="saveUpdateColumn(column)" [disabled]="isSaveColDisabled()">
                                  <i class="fa-regular fa-check"></i>
                                </button>
                                <button mat-button color="cancel" title="Cancel" class="show-always" (click)="cancelSaveColumn(column)">
                                  <i class="fa-regular fa-xmark clear-icon"></i>
                                </button>
                            </div>
                        </mat-form-field>
                      </ng-container>
                    </div>


                    <ng-template #showColumn>
                      <span class="text-ellipse d-inline-block text-end" style="width:120px;vertical-align:middle;">{{ column.colName || 'null' }}</span>
                      <button mat-button class="cell-hover-action-item button-smaller-icon w-16 kebab-button" *ngIf="column.colName !== 'Retained Earnings'" mat-icon-button [matMenuTriggerFor]="menu" [disabled]="isColEditable() || (editRowUUID !== '')">
                        <i class="fas fa-ellipsis-vertical"></i>
                      </button>

                      <mat-menu #menu xPosition="after" yPosition="below" class="template-block-main">
                        <mat-list role="list" class="templates-list-items card-body p-0">
                          <mat-list-item role="listitem" [disabled]="column.isFromRf ||  shortCutMenuDetails.isenglock !== 0">
                              <span class="flexbox-row gap-8" (click)="editColName(column);" [disabled]="column.isFromRf || shortCutMenuDetails.isenglock !== 0">
                                <i class="fa-regular fa-pen fs-15"></i>
                                <span class="button-label">Edit</span>
                              </span>
                          </mat-list-item>
                          <mat-list-item role="listitem" [disabled]="column.isFromRf || shortCutMenuDetails.isenglock !== 0">
                            <span class="flexbox-row gap-8" (click)="openDeleteColDialog(column);" [disabled]="column || shortCutMenuDetails.isenglock !== 0">
                                <i class="fa-regular fa-trash-can"></i>
                                <span class="button-label">Delete</span>
                            </span>
                          </mat-list-item>
                        </mat-list>
                      </mat-menu>
                    </ng-template>
                  </mat-header-cell>

                  <mat-cell *matCellDef="let element" class="text-end justify-content-end" style="min-width: 150px;max-width:150px;" [ngClass]="{'table-col-editable': editColumnUUID === column.columnUUID}">
                    <div *ngIf="notAnAddAndTotalRow(element); else endTotal" class="full-row flex-box" [ngClass]="{'default-row' : isDefaultRow(element)}">
                      <div class="valueDisplay ellipse " title="{{showFormattedNumber(getColValue(element, column.columnUUID))}}" *ngIf="!(isRowInAddMode(element) || isRowInEditMode(element)); else editRow">
                        {{ showFormattedNumber(getColValue(element, column.columnUUID)) }}
                      </div>
                      <ng-template #editRow>
                        <mat-form-field class="fixed-label label-none form-field-medium" floatLabel="always">
                          <input #txtVal matInput type="number" class="text-end" ngModel="{{ getColValue(element, column.columnUUID) }}" pattern="[0-9]*" [disabled]="isDefaultRow(element) || (element.rowUUID === editRowUUID && element.year !== editYear)" (blur)="editInput = ''; setColvalue(element, column.columnUUID, txtVal.value)" />
                        </mat-form-field>
                      </ng-template>
                    </div>
                    <ng-template #endTotal>
                      <span class="fw-semibold" style="padding-right:10px;" *ngIf="isAddRowBtn(element); else totalBal"></span>
                      <ng-template #totalBal>
                        <span *ngIf="!(element.rowUUID === 'crossCheck')" class="fw-semibold" style="padding-right:10px;" title="{{showFormattedNumber(getTotEndBalance(element.year, column.columnUUID))}}">
                          {{ showFormattedNumber(getTotEndBalance(element.year, column.columnUUID)) }}</span>
                      </ng-template>
                    </ng-template>
                  </mat-cell>
                </ng-container>

                <mat-header-row mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;let i = index;let islast =last;" cdkDrag (cdkDragStarted)="dragStarted(row, i)" [cdkDragData]="row" [ngClass]="{'totalRow': row.rowUUID == 'endTotalBal', 'table-row-editable': isRowInEditMode(row) || isRowInAddMode(row)}" [hidden]="isCrossCheckValueZero(row)"></mat-row>

                <!-- Group header  -->
                <ng-container matColumnDef="groupHeader">
                  <mat-cell colspan="999" *matCellDef="let group" class="fw-semibold pointer" style="padding-left:16px;" title="Year {{group[groupByColumns[group.level-1]]}}">
                    <i title="Collapse All" class="fa-regular fa-arrow-down-left-and-arrow-up-right-to-center fs-3 text-primary" *ngIf="group.expanded"></i>
                    <i title="Expand All" class="fa-regular fa-arrow-up-right-and-arrow-down-left-from-center fs-3 text-primary" *ngIf="!group.expanded"></i>
                    <span class="ms-2">Year {{group[groupByColumns[group.level-1]]}}</span>
                  </mat-cell>
                </ng-container>

                <mat-row *matRowDef="let row; columns: ['groupHeader']; when: isGroup" (click)="groupHeaderClick(row)"></mat-row>

              </mat-table>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-auto d-flex align-items-center justify-content-center bg-gray-1 py-2 px-3 hover-action" *ngIf="notes && notes.length != 0">
        <ng-container *ngIf="!isFooterNoteEdited">
          <p class="title d-flex flex-row align-items-center gap-8" style="min-height:36px;">{{footerNote}}
              <button mat-button class="button-small-icon hover-action-item" (click)="editFooterNotes();">
                <i class="fa-regular fa-pen fs-15"></i>
              </button>
          </p>
          <!-- <p></p>
          <button class="transparent-btn bs-edit-btn bs-date" (click)="editFooterNotes();">
            <i class="fa-regular fa-pen"></i>
          </button> -->
        </ng-container>
        <ng-container *ngIf="isFooterNoteEdited">
          <mat-form-field class="fixed-label form-field-medium icon-form-after action-2" style="width: 300px">
            <input matInput [(ngModel)]="footerNote" [ngModelOptions]="{standalone: true}" #focusInputField>
            <div matSuffix class="actions border-start">
              <button mat-button color="success" title="Save" class="show-always" (click)="saveFooterNote()">
                <i class="fa-regular fa-check"></i>
              </button>
              <button mat-button color="cancel" title="Cancel" class="show-always" (click)="cancelEditFooterNote();">
                <i class="fa-regular fa-xmark clear-icon"></i>
              </button>
            </div>
          </mat-form-field>
          <!-- <div class="footer-input flex-box-col">
            <div class="pc-add-col">
              <input type="text" class="text-end" [(ngModel)]="footerNote" [ngModelOptions]="{standalone: true}" #focusInputField>
            </div>
            <button mat-button class="button-text pc-icon" title="Close" (click)="cancelEditFooterNote();">
                <i class="fa-regular fa-xmark"></i>
            </button>
            <button mat-button class="button-text pc-icon" title="Done" (click)="saveFooterNote()">
                <i class="fa-regular fa-check"></i>
            </button>
          </div> -->
        </ng-container>
      </div>
    </div>
  </mat-drawer-content>

  <mat-drawer #drawer appResizableDrawer resizeDirection="left" [minWidth]="600" [maxWidth]="700" (resizeEvent)="onResizePanelEnd($event)" class="order-2" style="width: 600px;">
    <div class="toogle-button-block button-block-right">
      <button mat-button class="button-small-icon toogle-button" (click)="drawer.toggle()"></button>
      <div class="toogle-content d-flex">
        <h6 class="title">Preview</h6>
      </div>
    </div>

    <div class="content-block stockholder-container-aside flex-1">
      <div class="stockholder-container-aside-body">
        <stockholder-equity-preview isPreview="true" class="h-100 flex-column d-flex"></stockholder-equity-preview>

      </div>

    </div>
  </mat-drawer>
</mat-drawer-container>


<!--New added columns limit reached dialog-->
<ng-template #limitReachedDialog>
  <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
    <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
      <h4 class="title text-center">Maximum column limit is reached</h4>
      <button color="error" class="close" [mat-dialog-close]="false">
          <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>

    <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">

    </div>

    <div mat-dialog-actions class="dialog-footer button-group" (click)="$event.stopPropagation()">
        <button mat-button mat-flat-button class="button-normal" color="primary" [mat-dialog-close]="true">Close</button>
    </div>
  </div>
</ng-template>

<!-- delete column popup-->
<ng-template #deleteConfirmDialog let-data>
  <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
    <div class="dialog-header d-flex flex-column align-items-center p-0">
      <span class="badge badge-error badge-circle icon-bordered-error">
        <i class="fa-regular fa-trash-can text-error"></i>
      </span>
      <h4 class="title text-center">
        Delete {{data.toDelete}}
      </h4>
      <button color="error" class="close" [mat-dialog-close]="false">
          <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>

    <div class="content dialog-body-content text-center gap-8 mt-2 mb-32">
      <p>Are you sure you want to delete this {{data.toDelete}}?</p>
      <p>This action cannot be undone.</p>
    </div>

    <div mat-dialog-actions class="dialog-footer button-group" (click)="$event.stopPropagation()">
        <button mat-button mat-stroked-button class="button-normal" color="dark" [mat-dialog-close]="false">Cancel</button>
        <button mat-button mat-flat-button class="button-normal" color="error" [mat-dialog-close]="true" (click)="data.toDelete === 'Row' ? deleteRow() : deleteColumn()">Delete</button>
    </div>
  </div>
</ng-template>

<!--dialog layout-->

<ng-template #notesFSLinkingDialog>
  <div class="notes-fs-link-dialog countable-dialog mh-100 h-100 right-drawer-dialog" style="width: 350px;">
    <div mat-dialog-title class="dialog-header p-2">
      <h4 class="title">Link Notes to Financial Statement</h4>
      <button class="close" [mat-dialog-close]><i class="fa-regular fa-xmark clear-icon"></i></button>
    </div>

    <div mat-dialog-content class="dialog-body-content tempaltes-list p-0 h-100 overflow-hidden">
      <div class="template-block-main">
        <div class="header px-2 d-flex flex-column gap-8 w-100">
          <mat-form-field class="fixed-label w-100" floatLabel="always">
            <mat-label>Financial Statement Item to Link:</mat-label>
            <mat-select [(ngModel)]="notesSource" (ngModelChange)="changednotesLinks()" placeholder="Select">
                  {{apiResponse.year1.year}}
                  <mat-option class="fs-items-option" *ngFor="let option of apiResponse.year1.rows" [value]="option">
                      {{option?.formattedName ? option.formattedName : option.name}}
                  </mat-option>
                  <ng-container *ngIf="apiResponse['year2']">
                    {{apiResponse.year2.year}}
                    <mat-option class="fs-items-option" *ngFor="let option of apiResponse.year2.rows" [value]="option">
                      {{option?.formattedName ? option.formattedName : option.name}}
                    </mat-option>
                  </ng-container>
            </mat-select>
          </mat-form-field>

          <h5 class="title">Select notes to link:</h5>

          <mat-form-field class="fixed-label w-100 icon-field-left label-none" floatLabel="always">
            <mat-label>Search</mat-label>
            <input matInput id="searchKeyword" name="searchKeyword" [(ngModel)]="searchKeyword" (keyup.backspace)="searchNotes($event.target.value)" (keyup)="searchNotes($event.target.value)" #searchField placeholder="Search" maxlength="100" autocomplete="off">
            <span matPrefix>
                <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
            </span>
          </mat-form-field>
        </div>

        <div class="templates-list w-100 overflow-auto">
          <div class="d-flex p-2 w-100">
            <mat-checkbox [checked]="isSelectAll" [(ngModel)]="isSelectAll" (change)="selectAll($event);disablegreenbutton=false;" id="isSelectAll" name="selectAll">
              Select all
            </mat-checkbox>
          </div>
          <ng-container *ngFor="let category of notes; trackBy: trackByRecords;let i=index">
            <mat-accordion *ngIf="category.notes" #accordion="matAccordion" multi="true">
              <mat-expansion-panel [expanded]="category.isExpand">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="title-content" [ngClass]="{'active': category.is_checked == true, 'searchActive': category?.highlight}" title="{{category.engNoteId}}. {{category.name}}">
                        <mat-checkbox (change)="is_recordChecked(i,'category');disablegreenbutton=false;" [checked]="category.is_checked" (click)="$event.stopPropagation()">
                        </mat-checkbox>
                        <span class="togglable-icon">
                            <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                        </span>
                        <span class="item-icon">
                          <i class="fa-regular fa-folder-bookmark"></i>
                        </span>
                        <span class="item-title text-ellipse">{{category.engNoteId}}. {{category.name}}</span>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list role="list" class="templates-list-items level-one" *ngFor="let note of category.notes;let j=index">
                    <mat-list-item role="listitem" [ngClass]="{'active': note.is_checked == true, 'searchActive': note?.highlight}" title="{{note.engNoteId}}. {{note.name}}">
                        <mat-checkbox class="list-item-content" (change)="is_recordChecked(i,'subcategory',j);disablegreenbutton=false;" [checked]="note.is_checked" (click)="$event.stopPropagation()">
                          <span class="d-flex flex-row gap-4 align-items-center overflow-hidden">
                            <span class="item-icon">
                              <img src="/assets/images/icons/notes-icon.svg" alt="icon"/>
                            </span>
                            <span class="item-title text-ellipse">{{note.engNoteId}}. {{note.name}}</span>
                          </span>
                        </mat-checkbox>
                    </mat-list-item>
                </mat-list>
              </mat-expansion-panel>
            </mat-accordion>

            <ng-container *ngIf="!category.notes">
              <mat-list role="list" class="templates-list-items">
                  <mat-list-item role="listitem" [ngClass]="{'searchActive': category?.highlight}" title="{{category.engNoteId}}. {{category.name}}">
                      <mat-checkbox class="list-item-content" (change)="is_recordChecked(i,'category');disablegreenbutton=false;"
                        [checked]="category.is_checked" (click)="$event.stopPropagation()" [ngClass]="{'active': category.is_checked == true}">
                        <span class="d-flex flex-row gap-4 align-items-center overflow-hidden">
                          <span class="item-icon">
                            <img src="/assets/images/icons/notes-icon.svg" alt="icon"/>
                          </span>
                          <span class="item-title text-ellipse">{{category.engNoteId}}. {{category.name}}</span>
                        </span>
                      </mat-checkbox>
                  </mat-list-item>
              </mat-list>
            </ng-container>
        </ng-container>
        </div>
      </div>
    </div>
    <div dialog-actions class="dialog-footer button-group p-2">
      <button mat-button mat-flat-button color="primary" class="button-medium flex-1" *ngIf="!disablegreenbutton" (click)="saveLinkNotes()" [mat-dialog-close] [disabled]="shortCutMenuDetails.isenglock !== 0">
        Link/Unlink Notes {{getCheckedNotes().length>0?"("+getCheckedNotes().length+")":''}}
      </button>
      <button mat-button mat-flat-button color="primary" class="button-primary flex-1" *ngIf="notesSource.notes && notesSource.notes.length && disablegreenbutton" [disabled]="disablegreenbutton ||shortCutMenuDetails.isenglock !== 0" (click)="saveLinkNotes()">
        Linked notes {{notesSource.notes.length>0?"("+notesSource.notes.length+")":''}}
      </button>
    </div>
  </div>
</ng-template>

<!--Roll forwarded row editing error dialog-->
<ng-template #rollForwardedWarningDialog>
  <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
    <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center" p-0>
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
      <h4 class="title text-center">Prior year figures are already finalized.</h4>
      <button color="error" class="close" [mat-dialog-close]="false">
          <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>

    <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
      <p>Any change in these figures will result in mismatch from prior year final financial statements.</p>
      <p class="fw-semibold">Are you sure you want to make the change ?</p>
    </div>

    <div mat-dialog-actions class="dialog-footer button-group" (click)="$event.stopPropagation()">
        <button mat-button mat-stroked-button class="button-normal" color="dark" [mat-dialog-close]="false" (click)="cancelEditRollForwRows()">Cancel</button>
        <button mat-button mat-flat-button class="button-normal" color="primary" [mat-dialog-close]="true" (click)="editRollForwRows()">Ok</button>
    </div>
  </div>
</ng-template>
